module.exports = {"id":"224921","name":"Adrián Marín","rating":"72","photo":"./data/images/photos/2/224921.png","club":{"name":"Villarreal CF","logo":"./data/images/clubs/VillarrealCF.png"},"positions":["DG","DLG","MG"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AdrianMarin0.json
// module id = 108
// module chunks = 0